/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Samples_Carrier_OptionalInputs */

const en_samples_carrier_optional = /** @type {(inputs: Samples_Carrier_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrier (optional)`)
};

const es_samples_carrier_optional = /** @type {(inputs: Samples_Carrier_OptionalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Transportista (opcional)`)
};

/**
* | output |
* | --- |
* | "Carrier (optional)" |
*
* @param {Samples_Carrier_OptionalInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const samples_carrier_optional = /** @type {((inputs?: Samples_Carrier_OptionalInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Samples_Carrier_OptionalInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_samples_carrier_optional(inputs)
	return es_samples_carrier_optional(inputs)
});